<template>
  <div class="login-page">
    <v-container class="mt-4" fluid fill-height>
      <v-row align="center" justify="center">
        <v-spacer></v-spacer>
        <v-col cols="12" sm="8" md="6">
          <v-card class="elevation-12">
            <v-toolbar dark v-bind:class="[isValis ? 'header-color-valis' : isCpmMode ? 'header-color-cpm-rakuten' : 'header-color']">
              <v-toolbar-title class="toolbar-title">{{ $t("login.title") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="checkLogin">
                <v-text-field
                  prepend-icon="mdi-account"
                  v-model="email"
                  :rules="emailRules"
                  :label="$t('login.form.email.label')"
                  required
                  variant="underlined"
                ></v-text-field>
                <v-text-field
                  prepend-icon="mdi-lock"
                  v-model="password"
                  :append-icon="pwdflg ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="pwdflg ? 'text' : 'password'"
                  :label="$t('login.form.password.label')"
                  counter
                  :rules="passwordRules"
                  required
                  variant="underlined"
                  @click:append="pwdflg = !pwdflg"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-alert v-if="error" :value="true" outlined color="error" type="error">
                  <span v-html="error"></span>
                </v-alert>
                <v-btn
                  type="submit"
                  :disabled="!valid"
                  @click="loginButtonClick"
                >{{ $t("login.form.submit") }}</v-btn>
              </v-form>
              <div class="text-right">
                <router-link :to="'forgot'">{{ $t("login.link.forgot") }}</router-link>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Login',
  data: function () {
    return {
      valid: true,
      email: '',
      emailRules: [
        (v) => !!v || this.$t('commons.validation.email.required'),
        (v) => /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) || this.$t('commons.validation.email.invalid')
      ],
      password: '',
      passwordRules: [
        (v) => !!v || this.$t('commons.validation.password.required'),
        (v) => v.length >= 12 || this.$t('commons.validation.password.short')
      ],
      pwdflg: false,
      error: undefined,
      isValis: false,
      isCpmMode: false
    }
  },
  methods: {
    ...mapActions('auth', ['login', 'setLoginError']),
    logout: function () {
      this.$router.replace('/logout').catch(err => {
        // logout の時 VueRouter の  NavigationGuard から生成される login ページへの router.replace の Redirect エラー出力を省略する
        if (!err.message.includes('Redirected when going from')) {
          throw err
        }
      })
    },
    loginButtonClick: function () {
      if (this.$refs.form.validate()) {
        this.error = null
        let userName = this.email
        let password = this.password
        this.login({ userName, password })
          .then((result) => {
            this.error = undefined
            if (this.$route.query.redirect) {
              this.$router.replace(this.$route.query.redirect)
            } else {
              this.$router.push('/loginRouteBranch')
            }
          })
          .catch((err) => {
            console.log(err)
            switch (err.code) {
              case 'NotAuthorizedException':
                if (err.message === 'Password attempts exceeded') {
                  this.error = this.$t('commons.cognito.limitExceeded', [err.message])
                } else {
                  this.error = this.$t('commons.cognito.notAuthorized', [err.message])
                }
                break
              case 'InvalidParameterException':
                this.error = this.$t('commons.cognito.invalidParam', [err.message])
                break
              case 'InvalidPasswordException':
              case 'UserNotFoundException':
                this.error = this.$t('commons.cognito.invalidUser', [err.message])
                break
              case 'LimitExceededException':
                this.error = this.$t('commons.cognito.limitExceeded', [err.message])
                break
              default:
                this.error = this.$t('commons.cognito.otherLoginError', [err.message])
                break
            }
          })
        // エラーが発生している場合はエラーの内容を返す
        this.setLoginError(this.error)
      }
    },
    checkLogin: function () {
      return this.$refs.form.validate()
    }
  },
  mounted: function () {
    if (process.env.ProjectCode === '301') {
      this.isValis = true
    }
    if (process.env.ProjectCode === '111') {
      this.isCpmMode = true
    }
  }
}
</script>
<style scoped>
.header-color {
  background-color: #4b7001 !important;
}
.header-color-valis {
  background-color: #093493 !important;
}
.header-color-cpm-rakuten {
  background-color: #BF0000 !important;
}
.login-page {
  min-height: 100%;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
}
.toolbar-title {
  color: #FFFFFF !important;
}
</style>
